<script>
    import PatientEncounterPatientDetails from "../components/PatientEncounterPatientDetails.svelte";
    import PatientEncounterProcedureDetails from "../components/PatientEncounterProcedureDetails.svelte";
    import PatientEncounterPatientAlertsAndDocuments from "../components/PatientEncounterPatientAlertsAndDocuments.svelte";
    import PatientEncounterPatientContactDetails from "../components/PatientEncounterPatientContactDetails.svelte";

    export let patientDetails = {},
        patientContacts = [],
        procedureDetails = {},
        doctorDetails = {},
        billingData = [],
        doctorProviders = [],
        patientEncounter,
        encounterId,
        isNotesInEdit = false,
        disableChangeProviderNo = false,
        logsLoaded = false,
        eclipseLogsData = [],
        isFromCalendarList = false,
        reloadPatientDetails = () => {},
        reloadDoctorDetails = () => {},
        reloadProcedureDetails = () => {},
        updatePatientEncounter = () => {},
        loadEncounterStatusOfPatient = () => {},
        reloadPatientEncounter = () => {};

    export let notesRef;
</script>

<div class="relative flex-1">
    <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
        <PatientEncounterPatientDetails
            {patientDetails}
            {billingData}
            {encounterId}
            {isFromCalendarList}
            bind:patientEncounter
            bind:logsLoaded
            bind:eclipseLogsData
            {reloadPatientDetails}
            {updatePatientEncounter}
            {loadEncounterStatusOfPatient}
            {reloadPatientEncounter}
        />

        <PatientEncounterProcedureDetails
            {procedureDetails}
            {doctorDetails}
            {patientEncounter}
            {doctorProviders}
            {disableChangeProviderNo}
            {isFromCalendarList}
            {reloadDoctorDetails}
            {reloadProcedureDetails}
        />

        <!-- <PatientEncounterDoctorDetails
            {patientEncounter}
            {doctorDetails}
            {doctorProviders}
            {reloadDoctorDetails}
        /> -->

        <PatientEncounterPatientAlertsAndDocuments
            bind:isInEdit={isNotesInEdit}
            bind:this={notesRef}
            bind:patientDetails
            {patientEncounter}
            {reloadPatientDetails}
        />

        <PatientEncounterPatientContactDetails
            patientID={patientDetails.id}
            {patientContacts}
            {isFromCalendarList}
            {reloadPatientDetails}
        />
    </div>
</div>
